import type { TFunction } from 'i18next';
import {
  IconBBCH,
  IconChart,
  IconDew,
  IconNDVI,
  IconSortList,
  IconT,
  IconWater,
} from './icons';

export const getFilterParametersMap = (t: TFunction) => ({
  name: {
    id: 'name',
    label: t('labels.name'),
    Icon: IconSortList,
  },
  bbchAI: {
    id: 'bbchAI',
    label: 'BBCH',
    Icon: IconBBCH,
  },
  temperature: {
    id: 'temperature',
    label: t('metrics.temperature'),
    Icon: IconT,
  },
  ndvi: {
    id: 'ndvi',
    label: 'NDVI',
    Icon: IconNDVI,
  },
  gdd: {
    id: 'gdd',
    label: 'GDD',
    Icon: IconChart,
  },
  humidity: {
    id: 'humidity',
    label: t('metrics.humidity'),
    Icon: IconWater,
  },
  dew: {
    id: 'dew',
    label: t('metrics.dewPoint'),
    Icon: IconDew,
  },
});
